import { IWakeupLoginForm } from 'common/interface/props';
import React from 'react';
import { useForm } from 'react-hook-form';
import io from 'socket.io-client';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';

import { TargetSolTypeRole, WAKEUP_FORM_DATA } from '../../common/common.constatns';
import { axiosCustom } from '../../common/common.function';
import { wakeupLoginRequest } from '../../redux_modules/wakeup-login';
import { RootState } from '../../redux_modules';
import withReactContent from 'sweetalert2-react-content';

// atomic components
import Grid from 'components/UI/atoms/Grid';
import InputWrap from 'components/UI/molecules/InputWrap';
import TextField from 'components/UI/atoms/TextField';
import FormWrap from 'components/UI/molecules/FormWrap';
import Button from 'components/UI/atoms/Button';
import ChannelIOButton from 'components/UI/organisms/ChannelIOButton';

// etc
import { FormError } from 'components/form/form-error';
import Text from 'components/UI/atoms/Text';
import CheckBox from 'components/UI/atoms/CheckBox';
import Select from 'components/UI/atoms/Select';
import FixedGrid from 'components/UI/atoms/FixedGrid';
import { useNavigate } from 'react-router-dom';

/**
 * 등록하려는 쇼핑몰 유효성 체크
 */
interface ISelectShops {
  COUPANG: {
    selected: boolean;
    isLogined: boolean;
  };

  WEMAKEPRICE: {
    selected: boolean;
    isLogined: boolean;
  };

  ST11: {
    selected: boolean;
    isLogined: boolean;
  };

  ALWAYZ: {
    selected: boolean;
    isLogined: boolean;
  };

  KAKAO: {
    selected: boolean;
    isLogined: boolean;
  };
}
export default function WakeupLoginFormAll({ solType, coupangSellerType }: IWakeupLoginForm) {
  //#region useForm
  // loop를 통해 같은 키값으로 컴포넌트를 생성하기 때문에 쇼핑몰 별로 useForm을 다르게 줘야함
  const {
    register: coupangRegister,
    handleSubmit: coupangHandleSubmit,
    getValues: coupangGetValues,
    setValue: coupangSetValue,
    watch: coupangWatch,
    formState: { errors: coupangErrors },
  } = useForm();

  const {
    register: st11Register,
    handleSubmit: st11HandleSubmit,
    getValues: st11GetValues,
    setValue: st11SetValue,
    watch: st11Watch,
    formState: { errors: st11Errors },
  } = useForm();

  const {
    register: wemakepriceRegister,
    handleSubmit: wemakepriceHandleSubmit,
    getValues: wemakepriceGetValues,
    setValue: wemakepriceSetValue,
    watch: wemakepriceWatch,
    formState: { errors: wemakepriceErrors },
  } = useForm();

  const {
    register: alwayzRegister,
    handleSubmit: alwayzHandleSubmit,
    getValues: alwayzGetValues,
    setValue: alwayzSetValue,
    watch: alwayzWatch,
    formState: { errors: alwayzErrors },
  } = useForm();
  //#endregion
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { shopInfo, wakeupInfo } = useSelector((state: RootState) => ({
    shopInfo: state.shopLogin,
    wakeupInfo: state.wakeupLogin,
  }));

  const MySwal = withReactContent(Swal);

  const coupangRef = React.useRef<HTMLDivElement>(null);
  const wemakepriceRef = React.useRef<HTMLDivElement>(null);
  const st11Ref = React.useRef<HTMLDivElement>(null);
  const alwayzRef = React.useRef<HTMLDivElement>(null);
  const submitDivPosition = React.useRef<HTMLDivElement>(null);

  //#region useState
  const [coupangVendorIdLimit, setCoupangVendorIdLimit] = React.useState(false);

  /**
   * 선택한 쇼핑몰 리스트
   */
  const [selectShops, setSelectShops] = React.useState<ISelectShops>(
    solType !== 'ALL'
      ? {
          COUPANG: {
            selected: false,
            isLogined: false,
          },
          WEMAKEPRICE: {
            selected: false,
            isLogined: false,
          },
          ST11: {
            selected: false,
            isLogined: false,
          },
          ALWAYZ: {
            selected: false,
            isLogined: false,
          },
          KAKAO: {
            selected: false,
            isLogined: false,
          },
          [solType]: {
            selected: true,
            isLogined: true,
          },
        }
      : {
          COUPANG: {
            selected: true,
            isLogined: false,
          },
          WEMAKEPRICE: {
            selected: false,
            isLogined: false,
          },
          ST11: {
            selected: false,
            isLogined: false,
          },
          ALWAYZ: {
            selected: false,
            isLogined: false,
          },
          KAKAO: {
            selected: false,
            isLogined: false,
          },
        },
  );
  //#endregion
  React.useEffect(() => {
    async function fetchData() {
      // 쇼핑몰 데이터 유효성 검사
      shopInfo.status !== 'SUCCESS' && navigate(`/${solType.toLowerCase()}/job/shop-login`);

      // 쿠팡일 경우 저장된 데이터 노출
      if (selectShops.COUPANG.selected === true) {
        const result = await axiosCustom.get(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/member/coupang/user-info`);

        coupangSetValue('shopId', result?.coupangInfo?.id);
        coupangSetValue('shopEtc5', result?.coupangInfo?.vendorId);
        coupangSetValue('shopEtc3', result?.coupangInfo?.accessKey);
        coupangSetValue('shopEtc4', result?.coupangInfo?.secretKey);

        setCoupangVendorIdLimit(result.coupangInfo.vendorIdLimit);
      }
    }

    fetchData();
  }, [solType, shopInfo, navigate]);

  //#region 스크롤 이벤트 ALL 타입에서만 동작할 거임
  const [submitPosition, setSubmitPosition] = React.useState<boolean>(solType === 'ALL'); // window 의 pageYOffset값을 저장

  function onScroll() {
    // 상품 등록 버튼 고정 위치
    const position1 = submitDivPosition.current?.getBoundingClientRect().bottom!;

    // html 최상단 위치 부터 상품 등록 버튼 고정 위치 까지의 거리 + 고정div 세로크기 (135px고정) 값이
    // 현재 화면의 세로 크기를 넘었다면 상품등록 하단 고정 풀음
    setSubmitPosition(position1 + 135 > window.innerHeight);
  }
  // 스크롤 이벤트 리스너 추가
  React.useEffect(() => {
    solType === 'ALL' && window.addEventListener('scroll', onScroll);
    return () => {
      solType === 'ALL' && window.removeEventListener('scroll', onScroll);
    };
  }, []);
  ////#endregion

  /**
   * 쇼핑몰에 맞는 useForm을 가져와보자..
   */
  function getUseForm(targetSolType: TargetSolTypeRole, name: string, value: any, key: string = '') {
    switch (targetSolType) {
      case TargetSolTypeRole.COUPANG:
        switch (name) {
          case 'register':
            return coupangRegister(key, value);
          case 'handleSubmit':
            return coupangHandleSubmit(value);
          case 'getValues':
            return coupangGetValues();
          case 'setValue':
            return coupangSetValue(key, value);
          case 'watch':
            return coupangWatch(key);

          case 'errors':
            return coupangErrors;
          default:
            break;
        }
        break;

      case TargetSolTypeRole.ST11:
        switch (name) {
          case 'register':
            return st11Register(key, value);
          case 'handleSubmit':
            return st11HandleSubmit(value);
          case 'getValues':
            return st11GetValues();
          case 'setValue':
            return st11SetValue(key, value);
          case 'watch':
            return st11Watch(key);

          case 'errors':
            return st11Errors;
          default:
            break;
        }
        break;
      case TargetSolTypeRole.WEMAKEPRICE:
        switch (name) {
          case 'register':
            return wemakepriceRegister(key, value);
          case 'handleSubmit':
            return wemakepriceHandleSubmit(value);
          case 'getValues':
            return wemakepriceGetValues();
          case 'setValue':
            return wemakepriceSetValue(key, value);
          case 'watch':
            return wemakepriceWatch(key);

          case 'errors':
            return wemakepriceErrors;
          default:
            break;
        }
        break;
      case TargetSolTypeRole.ALWAYZ:
        switch (name) {
          case 'register':
            return alwayzRegister(key, value);
          case 'handleSubmit':
            return alwayzHandleSubmit(value);
          case 'getValues':
            return alwayzGetValues();
          case 'setValue':
            return alwayzSetValue(key, value);
          case 'watch':
            return alwayzWatch(key);

          case 'errors':
            return alwayzErrors;
          default:
            break;
        }
        break;
      default:
        switch (name) {
          case 'register':
            return alwayzRegister(key, value);
          case 'handleSubmit':
            return alwayzHandleSubmit(value);
          case 'getValues':
            return alwayzGetValues(value);
          case 'setValue':
            return alwayzSetValue(key, value);

          case 'errors':
            return alwayzErrors;
          default:
            break;
        }
    }
  }

  /**
   * 쇼핑몰에 맞는 useRef를 가져와보자..
   */
  function getUseRef(targetSolType: TargetSolTypeRole) {
    switch (targetSolType) {
      case TargetSolTypeRole.COUPANG:
        return coupangRef;
      case TargetSolTypeRole.WEMAKEPRICE:
        return wemakepriceRef;
      case TargetSolTypeRole.ST11:
        return st11Ref;
      case TargetSolTypeRole.ALWAYZ:
        return alwayzRef;

      default:
        break;
    }
  }

  /**
   * 쇼핑몰 로그인 실행 함수
   */
  async function onLoginSubmit(specificProduct = false, targetSolType: TargetSolTypeRole) {
    const data = getUseForm(targetSolType, 'getValues', '');

    data.shopCode = WAKEUP_FORM_DATA[targetSolType].code;
    data.shopName = WAKEUP_FORM_DATA[targetSolType].name.type1;

    // 공백제거
    Object.keys(data).map((key: string) => {
      // 올웨이즈는 ID앞에 공백을 허용함
      if (key === `shopId` && targetSolType === 'ALWAYZ') {
        return false;
      }

      if (key !== 'loginError') {
        data[key] = data[key].trim();
      }
    });

    const reqData: any = {
      scrapShopCode: data.shopCode,
      scrapShopId: data.shopId,
      scrapShopPw: data.shopPw,
      scrapShopEtc1: data.shopEtc1,
      scrapShopEtc2: data.shopEtc2,
      scrapShopEtc3: data.shopEtc3,
      scrapShopEtc4: data.shopEtc4,
      scrapShopEtc5: data.shopEtc5,
      scrapShopEtc6: data.shopEtc6,
      solType: targetSolType,
      targetSolType,
      scrapType: 'NORMAL',
      prodCodes: null,
      coupangSellerType: '3P',
    };

    if (specificProduct === true) {
      // 특정 상품 등록하기
      let html;
      let html2;
      if (targetSolType === 'COUPANG') {
        html = `
          <div style="background: #f7f7f7; padding: 45px 20px; margin-bottom: 30px;">
              <p style="font-size: 1.11rem; font-weight:bold;padding-bottom:25px;">※ 주의 사항</p>
              <div style="font-size: .88rem; text-align:left">
                  플레이오토 상품 이전 기능을 이용 시 '상품등록' 작업만 가능하며, '상품수정' 작업은 진행되지 않습니다. <br/>
                  한번 이전한 상품의 재등록 작업을 진행하기 위해서는 먼저 ‘${WAKEUP_FORM_DATA[targetSolType].name.type3}’에 접속하여 등록된 상품을 직접 삭제해주시기 바랍니다.<br/>
                  <br/>

                  <div style="color: #FF3636; font-size: .88rem;">
                  ※ 입력하신 쇼핑몰 상품 코드는 ${WAKEUP_FORM_DATA[targetSolType].name.type3}에 새로운 상품으로 등록됩니다. <br/>
                  ※ ${WAKEUP_FORM_DATA[targetSolType].name.type3}에서 기존 상품을 삭제하지 않고 상품 이전 시 중복 등록이 발생할 수 있으므로 각별히 주의 부탁 드립니다.
                  </div>
              </div>
          </div>
          `;
        html2 = `<div style="background: #f7f7f7; padding: 45px 20px; margin-bottom: 30px;">
          <p style="font-size: 1.11rem; font-weight:bold;padding-bottom:25px;">※ 주의 사항</p>
          <div style="font-size: .88rem; text-align:left">
              플레이오토 상품 이전 기능을 이용 시 ‘상품 등록’ 작업만 가능하며, ‘상품 수정’ 작업은 진행되지 않습니다. <br/>
              한번 이전한 상품의 재등록 작업을 진행하기 위해서는 먼저 ‘${WAKEUP_FORM_DATA[targetSolType].name.type3}’에 접속하여 등록된 상품을 직접 삭제해주시기 바랍니다. <br/>
              <br/>

              <div style="color: #FF3636; font-size: .88rem;">
              ※ 입력하신 쇼핑몰 상품 코드는 ${WAKEUP_FORM_DATA[targetSolType].name.type3}에 새로운 상품으로 등록됩니다. <br/>
              ※ ${WAKEUP_FORM_DATA[targetSolType].name.type3}에서 기존 상품을 삭제하지 않고 상품 이전 시 중복 등록이 발생할 수 있으므로 각별히 주의 부탁 드립니다.
              </div>
          </div>
      </div>
      <div style="font-size: .88rem; padding: 10px 25px; line-height: 1.7;font-weight: 500">
      - 등록할 상품의 쇼핑몰 상품 코드(상품번호)를 엔터(Enter) 기준으로 입력해주세요. <br/>
      - 상품 코드는 한 줄에 1개씩 입력해주세요.
      </div>
          `;
      } else if (targetSolType === 'ALWAYZ') {
        html = `
          <div style="background: #f7f7f7; padding: 45px 20px; margin-bottom: 30px;">
              <p style="font-size: 1.11rem; font-weight:bold;padding-bottom:25px;">※ 주의 사항</p>
              <div style="font-size: .88rem; text-align:left">
                  플레이오토 상품 이전 기능을 이용 시 '상품등록' 작업만 가능하며, '상품수정' 작업은 진행되지 않습니다. <br/>
                  이 기능을 사용하여 상품등록시 상품이 중복 등록 될 수 있습니다.<br/>
                  <br/>

                  <div style="color: #FF3636; font-size: .88rem;">
                  ※ 입력하신 쇼핑몰 상품 코드는 ${WAKEUP_FORM_DATA[targetSolType].name.type3}에 새로운 상품으로 등록됩니다. <br/>
                  ※ 올웨이즈는 상품 삭제를 지원하지 않습니다. 기존에 존재하는 상품을 이전할 경우, 중복 등록이 발생 할 수 있으니, 각별히 주의해주시기 바랍니다.
                  </div>
              </div>
          </div>
          `;
        html2 = `
          <div style="background: #f7f7f7; padding: 45px 20px; margin-bottom: 30px;">
              <p style="font-size: 1.11rem; font-weight:bold;padding-bottom:25px;">※ 주의 사항</p>
              <div style="font-size: .88rem; text-align:left">
                  플레이오토 상품 이전 기능을 이용 시 '상품등록' 작업만 가능하며, '상품수정' 작업은 진행되지 않습니다. <br/>
                  이 기능을 사용하여 상품등록시 상품이 중복 등록 될 수 있습니다.<br/>
                  <br/>

                  <div style="color: #FF3636; font-size: .88rem;">
                  ※ 입력하신 쇼핑몰 상품 코드는 ${WAKEUP_FORM_DATA[targetSolType].name.type3}에 새로운 상품으로 등록됩니다. <br/>
                  ※ 올웨이즈는 상품 삭제를 지원하지 않습니다. 기존에 존재하는 상품을 이전할 경우, 중복 등록이 발생 할 수 있으니, 각별히 주의해주시기 바랍니다.
                  </div>
              </div>
          </div>
          <div style="font-size: .88rem; padding: 10px 25px; line-height: 1.7;font-weight: 500">
          - 등록할 상품의 쇼핑몰 상품 코드(상품번호)를 엔터(Enter) 기준으로 입력해주세요. <br/>
          - 상품 코드는 한 줄에 1개씩 입력해주세요.
          </div>
          `;
      }
      const { value: policy } = await Swal.fire({
        customClass: {
          popup: 'swal-custom-popup',
          header: 'swal-custom-header',
          title: 'swal-custom-title',
          content: 'swal-custom-content specificProduct',
          actions: 'swal-custom-actions',
          confirmButton: 'swal-custom-confirmButton',
          cancelButton: 'swal-custom-cancleBtn',
        },
        showCancelButton: true,
        cancelButtonText: '취소',
        confirmButtonText: '확인',
        title: '지정 상품 등록',
        html: html,
      });

      if (!policy) return false;

      // 지정 상품 등록하기
      const { value: prodCodes } = await Swal.fire({
        customClass: {
          popup: 'swal-custom-popup',
          header: 'swal-custom-header',
          title: 'swal-custom-title',
          content: 'swal-custom-content specificProduct',
          actions: 'swal-custom-actions',
          confirmButton: 'swal-custom-confirmButton',
          cancelButton: 'swal-custom-cancleBtn',
        },
        showCancelButton: true,
        cancelButtonText: '취소',
        confirmButtonText: `${WAKEUP_FORM_DATA[targetSolType].name.type2} 상품 등록`,
        input: 'textarea',
        inputPlaceholder: 'B1234566790\nB1234567890',
        title: '지정 상품 등록',
        html: html2,
        preConfirm: (input) => {
          if (!input) {
            Swal.showValidationMessage('가져올 쇼핑몰 상품코드를 입력하세요.');
          }
          return input;
        },
      });

      // 지정상품 상품 코드 리스트
      if (!prodCodes) return false;

      reqData.scrapType = 'SPECIFIC';
      reqData.prodCodes = prodCodes.split('\n').filter(Boolean);
    } else {
      reqData.scrapType = 'NORMAL';
      reqData.prodCodes = null;
    }

    // 쿠팡일 경우 유입경로 데이터 추가
    if (targetSolType === 'COUPANG') {
      reqData.coupangSellerType = coupangSellerType;
    }

    // 무한 로딩 화면 생성
    Swal.fire({
      title: `${WAKEUP_FORM_DATA[targetSolType].name.type1} 정보 유효성 검사중...`,
      html: '유효성 검사중 ...',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });

    // 쇼핑몰 로그인 실행
    const jobId = await shopLoginSend();

    // 쇼핑몰 로그인 소켓
    jobId && shopLoginSocket();

    // 쇼핑몰 로그인 실행
    async function shopLoginSend() {
      try {
        //쇼핑몰 로그인 통신
        const { jobId } = await axiosCustom.post(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/job/shop-login`, reqData);

        return jobId;
      } catch (error: any) {
        Swal.fire('오류', error.message, 'error');
        return false;
      }
    }

    // 쇼핑몰 로그인 소켓
    function shopLoginSocket() {
      //  소켓 연결
      const sockets = io(`${process.env.REACT_APP_BACKEND_ENDPOINT}`, {
        query: { jobId: jobId },
        transports: ['websocket'],
      });
      //  완료
      sockets.on('shopLogin', async (payload: any) => {
        interface IShopDummy3 {
          returnAddressSeq: string | any;
          sendAddressSeq: string | any;
        }
        let shopDummy3: IShopDummy3 = {
          returnAddressSeq: '',
          sendAddressSeq: '',
        };
        // 결과 응답일 경우
        if (payload.result) {
          if (targetSolType === 'ST11') {
            if (solType === 'ALL') {
              //11번가 어드민을 통해서 seq(출고지,반품/교환지)를 정상적으로 등록했을때만 작업 시작
              const { success, message, returnAddressData, sendAddressData } = await axiosCustom.post(
                `${process.env.REACT_APP_BACKEND_ENDPOINT}/api/job/${targetSolType.toLowerCase()}/scrap-default-address`,
                {
                  apiKey: data.shopEtc1,
                },
              );

              if (!success) {
                await Swal.fire({
                  title: '실패',
                  html: message,
                  icon: 'error',
                  showCancelButton: false,
                  confirmButtonText: '확인',
                });

                return false;
              }

              const swalResult = await MySwal.fire({
                customClass: {
                  popup: 'swal-custom-popup',
                  header: 'swal-custom-header',
                  title: 'swal-custom-title',
                  content: 'swal-custom-content',
                  actions: 'swal-custom-actions',
                  confirmButton: 'swal-custom-confirmButton',
                  cancelButton: 'swal-custom-cancleBtn',
                },
                title: '11번가 출고지, 반품/교환지 확인',

                html: (
                  <div className="shipping">
                    <Grid display="flex" direction="column" justifyContent="flex-end" bottom={200}>
                      <Text fontSize="18px" fontWeight={400}>
                        11번가 <b>출고지</b>, <b>반품/교환지</b>의 경우 11번가 어드민에 설정되어있는 기본주소로 자동 설정 됩니다.
                        <br />
                        <br />
                        아래 주소 정보로 11번가에 상품 이전을 원하지 않으신다면 취소 후 11번가 어드민에서 기본주소 재 설정 부탁드립니다.
                        <br />
                        <br />
                      </Text>
                    </Grid>

                    <div>
                      <p>출고지 주소</p>
                      <div>
                        <TextField variant="outlined" disabled style={{ width: '100%' }} value={sendAddressData.shippingPlaceAddress} />
                      </div>
                    </div>

                    <div>
                      <p>반품/교환지 주소</p>
                      <div>
                        {' '}
                        <TextField variant="outlined" disabled style={{ width: '100%' }} value={sendAddressData.shippingPlaceAddress} />
                      </div>
                    </div>
                  </div>
                ),

                cancelButtonText: '취소',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: '확인',
                width: 800,
                allowOutsideClick: false,
              });

              if (!swalResult.isConfirmed) {
                return false;
              }
              shopDummy3.returnAddressSeq = returnAddressData.returnAddressSeq;
              shopDummy3.sendAddressSeq = sendAddressData.sendAddressSeq;
            }
            if (solType === 'ST11') {
              // wakeup 테스트 계정만 배송사 고정
              if (data.shopId === 'pltowakeup') {
                sessionStorage.setItem('addressSeq', JSON.stringify({ sendAddressSeq: '26', returnAddressSeq: '208' }));
              }
              if (sessionStorage.getItem('addressSeq') === null) {
                await Swal.fire({
                  title: '실패',
                  html: '11번가 SellerOffice 통해 접속한 사용자만 사용이 가능합니다.SellerOffice 출고지, 반품/교환지 정보를 입력한 후, 접속해주시기 바랍니다.',
                  icon: 'error',
                  showCancelButton: true,
                  cancelButtonText: '취소',
                  confirmButtonText: '11번가 접속',

                  preConfirm: () => {
                    window.open('https://soffice.11st.co.kr/register/popupPlayauto.tmall?method=popupPlayauto');
                  },
                });

                Swal.close();
                return false;
              } else {
                const sessionAddressSeq = sessionStorage.getItem('addressSeq');
                let AddressSeq;
                if (sessionAddressSeq) {
                  AddressSeq = JSON.parse(sessionAddressSeq);
                }

                shopDummy3 = {
                  returnAddressSeq: '',
                  sendAddressSeq: '',
                };
                const shippingInfoExist = false;

                const { sendAddressData, returnAddressData } = await axiosCustom.post(
                  `${process.env.REACT_APP_BACKEND_ENDPOINT}/api/job/${targetSolType.toLowerCase()}/scrap-address`,
                  {
                    apiKey: data.shopEtc1,
                    sendAddressSeq: AddressSeq.sendAddressSeq,
                    returnAddressSeq: AddressSeq.returnAddressSeq,
                  },
                );

                const swalResult = await MySwal.fire({
                  customClass: {
                    popup: 'swal-custom-popup',
                    header: 'swal-custom-header',
                    title: 'swal-custom-title',
                    content: 'swal-custom-content',
                    actions: 'swal-custom-actions',
                    confirmButton: 'swal-custom-confirmButton',
                    cancelButton: 'swal-custom-cancleBtn',
                  },
                  title: shippingInfoExist ? '11번가 출고지, 반품/교환지 확인' : '11번가 출고지, 반품/교환지 선택',

                  html: (
                    <div className="shipping">
                      <div>
                        <p>출고지 주소</p>
                        <div>
                          {/* <TextField variant="outlined" disabled style={{ width: '100%' }} /> */}
                          <Select variant="outlined" style={{ width: '100%' }} id="st11-send-address-seq">
                            {typeof sendAddressData.sendAddressAddr === 'string' ? (
                              <option value={sendAddressData.sendAddressAddrSeq}>{sendAddressData.sendAddressAddr}</option>
                            ) : (
                              sendAddressData.sendAddressAddr.map((one: any, index: any) => (
                                <option key={index} value={sendAddressData.sendAddressAddrSeq[index]}>
                                  {one}
                                </option>
                              ))
                            )}
                          </Select>
                        </div>
                      </div>

                      <div>
                        <p>반품/교환지 주소</p>
                        <div>
                          {/* <TextField variant="outlined" disabled style={{ width: '100%' }} /> */}
                          <Select variant="outlined" style={{ width: '100%' }} id="st11-return-address-seq">
                            {typeof returnAddressData.returnAddressAddr === 'string' ? (
                              <option value={returnAddressData.returnAddressAddrSeq}>{returnAddressData.returnAddressAddr}</option>
                            ) : (
                              returnAddressData.returnAddressAddr.map((one: any, index: any) => (
                                <option key={index} value={returnAddressData.returnAddressAddrSeq[index]}>
                                  {one}
                                </option>
                              ))
                            )}
                          </Select>
                        </div>
                      </div>
                    </div>
                  ),

                  preConfirm: () => {
                    return {
                      st11SendAddressSeq: (document.getElementById('st11-send-address-seq') as HTMLInputElement).value,
                      st11ReturnAddressSeq: (document.getElementById('st11-return-address-seq') as HTMLInputElement).value,
                    };
                  },

                  cancelButtonText: shippingInfoExist ? '배송정보 수정' : '배송정보 등록',
                  showCloseButton: true,
                  showCancelButton: true,
                  confirmButtonText: '상품등록 시작',
                  width: 800,
                  allowOutsideClick: false,
                });

                if (swalResult.dismiss === MySwal.DismissReason.cancel) {
                  window.open('https://soffice.11st.co.kr/register/popupPlayauto.tmall?method=popupPlayauto');

                  return false;
                } else if (swalResult.value?.st11ReturnAddressSeq === 'none' || swalResult.value?.st11SendAddressSeq === 'none') {
                  await Swal.fire({
                    title: '실패',
                    html: '출고지, 반품/교환지는 필수입니다.',
                    icon: 'error',
                  });

                  return false;
                } else {
                  shopDummy3.returnAddressSeq = swalResult.value?.st11ReturnAddressSeq;
                  shopDummy3.sendAddressSeq = swalResult.value?.st11SendAddressSeq;
                }
              }
            }
          } else if (targetSolType === `ALWAYZ`) {
            //올웨이즈는 판매가 10% 세일가를 팀 구매가로 사용한다 동의 팝업, 취소시 로그인 실패
            const alwayzAgree = await MySwal.fire({
              title: '올웨이즈 약관 동의',
              html: (
                <div>
                  <span>1. 상품 등록이 시작되면 상품의 팀 구매가를 판매가의 10% 할인된 가격으로 판매됩니다.</span>
                  <br />
                  <br />
                  <span>예시: 판매가 10,000원이면 팀 구매가는 9,000원입니다.</span>
                  <br />
                  <br />
                  <span>2. 올웨이즈는 전 상품 무료배송입니다.(배송비 부과 불가)</span>
                  <br />
                  <br />
                  <span>동의하시겠습니까? </span>
                </div>
              ),
              showCancelButton: true,
              cancelButtonText: '취소',
              confirmButtonText: '확인',
            });
            // 동의하지 않았을 때
            if (!alwayzAgree.isConfirmed) {
              //총 3가지 조건을 통과했을때만 상품등록 시작
              //1.B895 DLL C# 로그인 아이디,비밀번호 체크 2.C# mailOrderBusinessNumber 체크 3. 판매가 10% 팀구매가 적용 동의
              Swal.close();
              return;
            }
          }
          // redux에 wakeup-login정보 쇼핑몰 별로 상태 업데이트
          dispatch(wakeupLoginRequest({ ...wakeupInfo.data, [targetSolType]: { wakeupInfo: { ...reqData, shopDummy3: shopDummy3 } } }));
          // 쇼핑몰 별 유효성 검사 업데이트 (선택여부, 로그인 여부)
          setSelectShops((shops) => {
            return { ...shops, [targetSolType]: { selected: true, isLogined: true } };
          });
          // 로그인 error input 제거
          getUseForm(targetSolType, 'setValue', false, 'loginError');

          // solType이 ALL이 아닐 때는 바로 상품 이전까지 실행 시킴
          if (solType !== 'ALL') {
            await onSubmit(specificProduct);

            return true;
          }
          Swal.close();
        } else {
          await Swal.fire({
            title: '실패',
            html: payload.message,
            icon: 'error',
            confirmButtonText: '확인',
          });
        }
      });
    }
  }

  // 쇼핑몰 로그인 완료 후 상품 이전 실행 함수
  async function onSubmit(specificProduct = false) {
    const targetSolType: TargetSolTypeRole[] = [];

    for (const one of Object.entries(selectShops)) {
      const key = one[0] as TargetSolTypeRole;
      const value = one[1];

      // 선택된 쇼핑몰
      if (value.selected) {
        // 로그인 안되었으면
        if (value.isLogined === false) {
          // await MySwal.fire('오류', `${WAKEUP_FORM_DATA[key].name.type1} 쇼핑몰 로그인 인증이 완료되지 않았습니다.`, 'error');
          // 해당 버튼으로 스크롤링
          getUseRef(key)?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });

          // 로그인 에러 메세지 노출
          getUseForm(key, 'setValue', true, 'loginError');
          return;
        }

        // 로그인 인증이 되었으면 추가
        targetSolType.push(key);
      }
    }
    // 인증 된 로그인 있으면 이동
    // 어차피 위에서 하나라도 인증 안되면 return으로 함수 끝나긴 함
    if (targetSolType.length > 0) {
      navigate(`/${solType}/job/scrap-prod`, { state: { targetSolType } });
    }

    return true;
  }

  // 이전 페이지 이동
  function goBack(e: any) {
    e.preventDefault();
    navigate(-1);
  }

  // 쿠팡전용 필드 이름 수정 함수
  const coupangLabelChange = (label: string) => {
    if (coupangSellerType === 'Retail') {
      if (label === '쿠팡 Wing ID') {
        label = '쿠팡 Supplierhub ID';
      }
    }

    return label;
  };

  return (
    <>
      <FormWrap>
        {solType === 'ALL' ? (
          <>
            <Grid display="flex" bottom={20} direction="column" justifyContent="flex-end" height={100}>
              <Text fontSize="18px" fontWeight={600}>
                사이트선택
              </Text>
            </Grid>

            <FormWrap.Top>
              {solType && solType === 'ALL' && (
                <Grid top={50}>
                  <InputWrap
                    label={'사이트 선택'}
                    labelWidth={160}
                    input={
                      <>
                        <Grid justifyContent="space-between" right={40} display={'flex'}>
                          {Object.entries(WAKEUP_FORM_DATA).map((one: any, index: any) => {
                            const key = one[0];
                            const value = one[1];
                            if (!value.isShop) return () => {};

                            // 이전 단계에서 11번가 / 11번가 단일을 선택 하였을 경우 11번가로 이전 불가능
                            if (key === TargetSolTypeRole.ST11 && ['A112', 'A113'].includes(shopInfo.data.shopInfo.scrapShopCode)) {
                              return () => {};
                            }
                            return (
                              <CheckBox
                                label={value.name.type1}
                                defaultChecked={key === TargetSolTypeRole.COUPANG}
                                name={key}
                                onClick={(e) => {
                                  setSelectShops((shops) => {
                                    if ((e.target as HTMLInputElement).checked) {
                                      return { ...shops, [key]: { selected: true, isLogined: false } };
                                    }
                                    return { ...shops, [key]: { selected: false, isLogined: false } };
                                  });
                                }}
                                value={key}
                              />
                            );
                          })}
                        </Grid>
                      </>
                    }
                  />
                </Grid>
              )}
            </FormWrap.Top>
          </>
        ) : (
          <></>
        )}

        {selectShops &&
          Object.entries(selectShops).map((one: any, index: number) => {
            const shop = one[0] as TargetSolTypeRole;
            const value = one[1];

            return WAKEUP_FORM_DATA[shop].isShop && value.selected ? (
              <form onSubmit={getUseForm(shop, 'handleSubmit', () => onLoginSubmit(false, shop))} key={index}>
                {solType === 'ALL' && (
                  <Grid display="flex" bottom={20} direction="column" justifyContent="flex-end" height={100}>
                    <Text fontSize="18px" fontWeight={600}>
                      {WAKEUP_FORM_DATA[shop].name.type1}
                    </Text>
                  </Grid>
                )}
                <FormWrap.Top>
                  {WAKEUP_FORM_DATA[shop].form.map((form: any, index: number) => {
                    return (
                      <>
                        <Grid top={50} key={index}>
                          {/* 지정 상품 등록하기 임시 주석 */}
                          {form.name === '지정 상품 등록하기' && solType === 'ALL' ? (
                            <></>
                          ) : (
                            <InputWrap
                              label={shop === 'COUPANG' ? coupangLabelChange(form.name) : form.name}
                              labelWidth={160}
                              input={
                                form.name === '지정 상품 등록하기' ? (
                                  <>
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <a
                                      href=""
                                      target="_blank"
                                      rel="noreferrer"
                                      style={{ textDecoration: 'underline', color: 'rgb(51,51,51)', fontSize: '0.88rem', fontWeight: 500, height: 'auto' }}
                                      onClick={async (_) => {
                                        _.preventDefault();
                                        onLoginSubmit(true, shop);
                                      }}
                                    >
                                      지정 상품 등록하기
                                    </a>
                                  </>
                                ) : (
                                  <TextField
                                    type={form.type || 'text'}
                                    //defaultValue={form.defaultValue} // TODO 실 적용 시 빼기
                                    placeholder={`${form.name} 를 입력해 주세요`}
                                    {...getUseForm(shop, 'register', form.validation, form.key)}
                                    readOnly={form.key.toString().indexOf('shopEtc5') > -1 && shop === TargetSolTypeRole.COUPANG ? coupangVendorIdLimit : false}
                                  />
                                )
                              }
                              error={
                                getUseForm(shop, 'errors', null) &&
                                getUseForm(shop, 'errors', null)[form.key]?.type === 'required' && <FormError errorMessage={'필수 입력 항목입니다.'} />
                              }
                              adornment={form.adornment || <></>}
                            />
                          )}
                        </Grid>
                      </>
                    );
                  })}

                  {shop === 'COUPANG' && (
                    <li
                      style={{
                        fontSize: '14px',
                        whiteSpace: 'pre-line',
                        position: 'relative',
                        paddingLeft: '15px',
                      }}
                      className="notices"
                    >
                      <span>1회 작업 성공 시 업체코드 변경은 불가하며, 타 쿠팡아이디 진행 시 새롭게 플레이오토 아이디를 생성 부탁 드립니다.</span>
                      {solType !== 'ALL' && (
                        <>
                          <br />
                          <span
                            style={{
                              fontSize: '14px',
                              whiteSpace: 'pre-line',
                              position: 'relative',
                              color: '#0072CE',
                              marginTop: '5px',
                            }}
                          >
                            상품 재등록은 ‘지정 상품 등록하기’ 기능을 이용해주세요.
                          </span>
                        </>
                      )}
                    </li>
                  )}

                  {solType === 'ALL' ? (
                    <Grid top={40}>
                      <Text fontWeight={600} fontSize="0.88rem">
                        이전 불가한 상품 유형
                      </Text>
                      <Grid top={20} />
                      <Text fontWeight={500} color="#8a8a8a" fontSize="0.83rem">
                        {WAKEUP_FORM_DATA[shop].restrictionType}
                      </Text>
                    </Grid>
                  ) : (
                    <></>
                  )}

                  {solType === 'ALL' ? (
                    <FormWrap.Bottom>
                      <Grid display="block" textAlign="center" ref={getUseRef(shop)}>
                        {selectShops[shop].isLogined ? (
                          <Text fontWeight={600} fontSize="1rem" color="#0072CE">
                            계정 인증이 완료되었습니다.
                          </Text>
                        ) : (
                          <>
                            <Button size="medium" width={200} color="main" type="submit">
                              계정 확인하기
                            </Button>
                            {getUseForm(shop, 'watch', null, 'loginError') && (
                              <FormError
                                errorMessage={`
                              ${WAKEUP_FORM_DATA[shop].name.type1} 쇼핑몰 로그인 인증이 완료되지 않았습니다.`}
                              />
                            )}
                          </>
                        )}
                      </Grid>
                    </FormWrap.Bottom>
                  ) : (
                    <></>
                  )}
                </FormWrap.Top>
                {shop === 'COUPANG' && <ChannelIOButton solType={shop} />}
              </form>
            ) : (
              <></>
            );
          })}

        {/* 상품등록 고정 위치를 알기 위해 */}
        <Grid id={'submitDivPosition'} ref={submitDivPosition}></Grid>
        <FixedGrid fixed={submitPosition} position="bottom" height="135px">
          <FormWrap.Bottom id={'submitDivFixed'}>
            <Grid display="flex" justifyContent="center">
              <Button size="medium" width={200} variant="outlined" color="main" onClick={goBack}>
                이전
              </Button>
              {Object.entries(selectShops).find((data) => {
                return data[1].selected === true;
              }) ? (
                <>
                  <Grid display="inline-block" right={20} />
                  <Button
                    size="medium"
                    width={200}
                    color="main"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      solType === 'ALL' ? onSubmit(false) : onLoginSubmit(false, solType as TargetSolTypeRole);
                    }}
                  >
                    상품 등록
                  </Button>
                </>
              ) : (
                <></>
              )}
            </Grid>
          </FormWrap.Bottom>
        </FixedGrid>
      </FormWrap>
    </>
  );
}
